import React from "react";
import {Page} from "components/common";
import {compose} from "recompose";
import {Nav, TabContent} from "reactstrap";
import EInvoiceTable from "./TableInvoice2";
import {Trans} from "react-i18next";
import {Switch} from "react-router-dom";

const getTable = (Statuses) => (props) =>
  (
    <EInvoiceTable
      filters={{
        extra_params: {
          Statuses,
        },
        raw: 'Type="ACCREC"',
        Type: "ACCREC",
      }}
      status={Statuses}
      {...props}
    />
  );

const All = getTable("DRAFT,SUBMITTED,AUTHORISED,PAID");
const Draft = getTable("DRAFT");
const AwaitingApproval = getTable("SUBMITTED");
const Approved = getTable("AUTHORISED");
const Paid = getTable("PAID");

export const ListEInvoices = ({match}) => {
  const [all, setAll] = React.useState(false)
  const [draft, setDraft] = React.useState(false)
  const [awaitingApproval, setAwaitingApproval] = React.useState(false)
  const [awaitingPayment, setAwaitingPayment] = React.useState(false)
  const [paid, setPaid] = React.useState(false)


  const gotToAll = () => {
    setAll(true)
    setDraft(false)
    setAwaitingApproval(false)
    setAwaitingPayment(false)
    setPaid(false)
  }

  const gotToDraft = () => {
    setAll(false)
    setDraft(true)
    setAwaitingApproval(false)
    setAwaitingPayment(false)
    setPaid(false)
  }

  const gotToAwaitingApproval = () => {
    setAll(false)
    setDraft(false)
    setAwaitingApproval(true)
    setAwaitingPayment(false)
    setPaid(false)
  }

  const gotToAwaitingPayment = () => {
    setAll(false)
    setDraft(false)
    setAwaitingApproval(false)
    setAwaitingPayment(true)
    setPaid(false)
  }

  const gotToPaid = () => {
    setAll(false)
    setDraft(false)
    setAwaitingApproval(false)
    setAwaitingPayment(false)
    setPaid(true)
  }
const tabContent={
    paddingTop: '30px',
    whiteSpace: 'nowrap'
  }
  return (
  <Page  className="inv-tabs nw-list">
    <div>
      <Nav tabs className="nw-tabs2 cursor-pointer">

        <div onClick={gotToAll} ><Trans>All</Trans></div>

        <div onClick={gotToDraft} ><Trans>Draft</Trans></div>

        <div onClick={gotToAwaitingApproval} ><Trans>Awaiting Approval</Trans></div>

        <div onClick={gotToAwaitingPayment} ><Trans>Awaiting Payment</Trans></div>

        <div onClick={gotToPaid} ><Trans>Paid</Trans></div>

      </Nav>
      <TabContent style={tabContent}>
        <Switch>
          {all == true ? <All/> : null}
          {draft == true ? <Draft/> : null}
          {awaitingApproval == true ? <AwaitingApproval/> : null}
          {awaitingPayment == true ? <Approved/> : null}
          {paid == true ? <Paid/> : null}
          <All />

        </Switch>
      </TabContent>
    </div>
  </Page>
  )
};

export const enhance = compose();

export default enhance(ListEInvoices);
